import React from 'react';
import BranchDetails from './branchdetails';
import { containerIprops } from './branchdetailsInterface';
import { selectors as globalDataSelector } from "../../../../state/features/common/globaldata";
import { useSelector } from "react-redux";

const BranchDetailsContainer = (props: containerIprops) => {
    const {
        globalData
    }: any = useSelector(
        state => ({
            globalData: globalDataSelector.globaldata(state),
        })
    );

    return (
        <BranchDetails
            onhandleClose={props.onhandleClose}
            fullfilmentBranchInfo={props?.fullfilmentBranchInfo}
            globalData={globalData}
        />
    );
};

export default BranchDetailsContainer;
